"use strict";
export const FULLSTORY_URL_HEADER = "X-FullStory-Url";
const AT_CURRENT_MOMENT = true;
const replayUrlAtCurrentMoment = (fullStory) => fullStory.getCurrentSessionURL ? fullStory.getCurrentSessionURL(AT_CURRENT_MOMENT) : fullStory("getSession", { format: "url.now" });
const fullStoryReplayUrl = () => {
  var _a;
  const fullStory = window.FS;
  if (!fullStory || fullStory.q) {
    return void 0;
  }
  try {
    return (_a = replayUrlAtCurrentMoment(fullStory)) != null ? _a : void 0;
  } catch (e) {
    return void 0;
  }
};
export { fullStoryReplayUrl };
